import { RegionService } from '../services/regionService';

export const buildRegionizeRoute = (path) => {
	const regionService = new RegionService();
	return `/${regionService.currentRegion()}/${path}`;
};
